// 风险管理模块配置
export const riskConfig = {
  // 模块基本信息
  name: '风险管理',
  description: '评估、预警、应对',
  icon: 'ExclamationCircleOutlined',
  bgColor: '#E8DAEF',
  iconColor: '#333333',
  
  // API 端点
  apiEndpoints: {
    risks: '/risk',
    create: '/risk',
    update: '/risk',
    delete: '/risk',
    monitoring: '/risk/monitoring',
    addMonitoring: '/risk/monitoring',
    deleteMonitoring: '/risk/monitoring',
    review: '/risk/review',
    addReview: '/risk/review',
    deleteReview: '/risk/review',
    types: '/risk/types',
    createType: '/risk/types',
    updateType: '/risk/types',
    deleteType: '/risk/types',
    assessment: '/risk/assessment',
    submitAssessment: '/risk/assessment',
    stats: '/risk/stats'
  },
  
  // 风险类型
  riskTypes: [
    {
      key: 'financial',
      name: '财务风险',
      icon: '💰',
      color: '#FF6B6B',
      description: '投资、理财、债务等财务相关风险'
    },
    {
      key: 'health',
      name: '健康风险',
      icon: '🏥',
      color: '#52C41A',
      description: '疾病、意外、医疗等健康相关风险'
    },
    {
      key: 'career',
      name: '职业风险',
      icon: '💼',
      color: '#1890FF',
      description: '工作、职业发展、技能等职业相关风险'
    },
    {
      key: 'relationship',
      name: '人际关系风险',
      icon: '👥',
      color: '#722ED1',
      description: '家庭、朋友、社交等人际关系风险'
    },
    {
      key: 'legal',
      name: '法律风险',
      icon: '⚖️',
      color: '#FAAD14',
      description: '合同、纠纷、合规等法律相关风险'
    },
    {
      key: 'technology',
      name: '技术风险',
      icon: '💻',
      color: '#13C2C2',
      description: '网络安全、数据泄露等技术相关风险'
    },
    {
      key: 'environment',
      name: '环境风险',
      icon: '🌍',
      color: '#A9DFBF',
      description: '自然灾害、环境污染等环境相关风险'
    },
    {
      key: 'other',
      name: '其他风险',
      icon: '❓',
      color: '#D9D9D9',
      description: '其他未分类的风险'
    }
  ],
  
  // 风险概率
  probabilityLevels: [
    {
      key: 'very_low',
      name: '极低',
      value: 1,
      color: '#52C41A',
      description: '几乎不可能发生'
    },
    {
      key: 'low',
      name: '低',
      value: 2,
      color: '#1890FF',
      description: '不太可能发生'
    },
    {
      key: 'medium',
      name: '中等',
      value: 3,
      color: '#FAAD14',
      description: '可能发生'
    },
    {
      key: 'high',
      name: '高',
      value: 4,
      color: '#FF4D4F',
      description: '很可能发生'
    },
    {
      key: 'very_high',
      name: '极高',
      value: 5,
      color: '#722ED1',
      description: '几乎肯定发生'
    }
  ],
  
  // 风险影响
  impactLevels: [
    {
      key: 'very_low',
      name: '极低',
      value: 1,
      color: '#52C41A',
      description: '影响很小，可以忽略'
    },
    {
      key: 'low',
      name: '低',
      value: 2,
      color: '#1890FF',
      description: '影响较小，可以接受'
    },
    {
      key: 'medium',
      name: '中等',
      value: 3,
      color: '#FAAD14',
      description: '影响中等，需要关注'
    },
    {
      key: 'high',
      name: '高',
      value: 4,
      color: '#FF4D4F',
      description: '影响较大，需要重视'
    },
    {
      key: 'very_high',
      name: '极高',
      value: 5,
      color: '#722ED1',
      description: '影响巨大，必须立即处理'
    }
  ],
  
  // 风险等级
  riskLevels: [
    {
      key: 'very_low',
      name: '极低风险',
      color: '#52C41A',
      description: '风险值1-4，可以接受'
    },
    {
      key: 'low',
      name: '低风险',
      color: '#1890FF',
      description: '风险值5-8，需要关注'
    },
    {
      key: 'medium',
      name: '中等风险',
      color: '#FAAD14',
      description: '风险值9-12，需要管理'
    },
    {
      key: 'high',
      name: '高风险',
      color: '#FF4D4F',
      description: '风险值13-16，需要重视'
    },
    {
      key: 'very_high',
      name: '极高风险',
      color: '#722ED1',
      description: '风险值17-25，必须立即处理'
    }
  ],
  
  // 风险状态
  riskStatus: [
    {
      key: 'active',
      name: '活跃',
      color: '#FF4D4F',
      description: '风险正在发生或可能发生'
    },
    {
      key: 'monitoring',
      name: '监控中',
      color: '#FAAD14',
      description: '风险正在被监控'
    },
    {
      key: 'mitigated',
      name: '已缓解',
      color: '#52C41A',
      description: '风险已经得到缓解'
    },
    {
      key: 'resolved',
      name: '已解决',
      color: '#1890FF',
      description: '风险已经完全解决'
    },
    {
      key: 'closed',
      name: '已关闭',
      color: '#D9D9D9',
      description: '风险已关闭'
    }
  ],
  
  // 风险承受能力评估问卷
  riskAssessment: {
    title: '风险承受能力评估',
    description: '通过以下问题评估您的风险承受能力，帮助制定合适的风险管理策略',
    questions: [
      {
        id: 1,
        question: '在投资理财方面，您更倾向于哪种方式？',
        options: [
          { value: 1, text: '保守型：只选择银行存款等低风险产品' },
          { value: 2, text: '稳健型：选择债券、基金等中等风险产品' },
          { value: 3, text: '平衡型：股票、基金等较高风险产品' },
          { value: 4, text: '积极型：期货、期权等高风险产品' },
          { value: 5, text: '激进型：追求高收益，愿意承担高风险' }
        ]
      },
      {
        id: 2,
        question: '如果投资亏损20%，您的反应是？',
        options: [
          { value: 1, text: '立即止损，不再投资' },
          { value: 2, text: '暂停投资，观望一段时间' },
          { value: 3, text: '保持现状，等待反弹' },
          { value: 4, text: '适当加仓，摊平成本' },
          { value: 5, text: '大幅加仓，相信会反弹' }
        ]
      },
      {
        id: 3,
        question: '对于职业发展，您更看重什么？',
        options: [
          { value: 1, text: '稳定性：工作稳定，收入有保障' },
          { value: 2, text: '平衡性：稳定与发展的平衡' },
          { value: 3, text: '发展性：有发展空间，愿意承担一定风险' },
          { value: 4, text: '挑战性：愿意接受挑战，追求高回报' },
          { value: 5, text: '冒险性：愿意冒险，追求最大收益' }
        ]
      },
      {
        id: 4,
        question: '面对不确定的未来，您的态度是？',
        options: [
          { value: 1, text: '谨慎：做好充分准备，避免风险' },
          { value: 2, text: '保守：选择稳妥的方案' },
          { value: 3, text: '中性：根据情况灵活调整' },
          { value: 4, text: '积极：主动应对，寻找机会' },
          { value: 5, text: '冒险：拥抱不确定性，追求机遇' }
        ]
      },
      {
        id: 5,
        question: '您的年龄阶段是？',
        options: [
          { value: 1, text: '60岁以上：退休阶段' },
          { value: 2, text: '50-59岁：临近退休' },
          { value: 3, text: '40-49岁：中年阶段' },
          { value: 4, text: '30-39岁：成家立业' },
          { value: 5, text: '30岁以下：年轻阶段' }
        ]
      }
    ],
    results: [
      {
        range: '5-10',
        level: '保守型',
        description: '您倾向于规避风险，追求稳定。建议选择低风险的投资和生活方式。',
        color: '#52C41A'
      },
      {
        range: '11-15',
        level: '稳健型',
        description: '您能够承担适度风险，追求稳定增长。建议选择中等风险的投资组合。',
        color: '#1890FF'
      },
      {
        range: '16-20',
        level: '平衡型',
        description: '您能够平衡风险和收益，适合多元化投资策略。',
        color: '#FAAD14'
      },
      {
        range: '21-25',
        level: '积极型',
        description: '您愿意承担较高风险，追求较高收益。建议做好风险管理。',
        color: '#FF4D4F'
      }
    ]
  },
  
  // 风险管理TIPS
  riskManagementTips: {
    title: '风险管理TIPS',
    tips: [
      {
        title: '风险识别',
        description: '主动识别潜在风险，建立风险清单',
        example: '定期评估工作、生活、投资中的潜在风险'
      },
      {
        title: '风险评估',
        description: '评估风险的概率和影响程度',
        example: '使用风险矩阵分析风险等级'
      },
      {
        title: '风险应对',
        description: '制定针对性的风险应对策略',
        example: '规避、转移、减轻、接受等策略'
      },
      {
        title: '风险监控',
        description: '持续监控风险变化，及时调整策略',
        example: '定期检查风险状态，更新应对措施'
      },
      {
        title: '风险复盘',
        description: '总结经验教训，改进风险管理',
        example: '分析风险事件，提炼管理经验'
      }
    ]
  },
  
  // 风险管理流程
  riskManagementProcess: {
    title: '风险管理五大流程',
    process: [
      {
        step: 1,
        title: '风险识别',
        description: '识别潜在的风险源和风险事件',
        icon: '🔍',
        color: '#1890FF'
      },
      {
        step: 2,
        title: '风险评估',
        description: '评估风险的概率和影响程度',
        icon: '📊',
        color: '#52C41A'
      },
      {
        step: 3,
        title: '风险应对',
        description: '制定风险应对策略和措施',
        icon: '🛡️',
        color: '#FAAD14'
      },
      {
        step: 4,
        title: '风险监控',
        description: '持续监控风险变化情况',
        icon: '👀',
        color: '#722ED1'
      },
      {
        step: 5,
        title: '风险复盘',
        description: '总结经验教训，改进管理',
        icon: '📝',
        color: '#FF6B6B'
      }
    ]
  },
  
  // 风险应对策略
  riskResponseStrategies: {
    title: '风险应对策略',
    strategies: [
      {
        title: '风险规避',
        description: '避免风险发生的策略',
        icon: '🚫',
        color: '#FF4D4F',
        examples: [
          '避免高风险投资',
          '不参与危险活动',
          '选择安全的合作伙伴'
        ]
      },
      {
        title: '风险转移',
        description: '将风险转移给第三方',
        icon: '🔄',
        color: '#1890FF',
        examples: [
          '购买保险',
          '签订合同条款',
          '外包风险业务'
        ]
      },
      {
        title: '风险减轻',
        description: '降低风险发生的概率或影响',
        icon: '📉',
        color: '#52C41A',
        examples: [
          '加强安全措施',
          '制定应急预案',
          '分散投资组合'
        ]
      },
      {
        title: '风险接受',
        description: '主动接受风险，承担后果',
        icon: '✅',
        color: '#FAAD14',
        examples: [
          '承担可控风险',
          '为高收益承担风险',
          '接受必要的风险'
        ]
      }
    ]
  },
  
  // 风险监控指标
  riskMonitoringMetrics: {
    title: '风险监控指标',
    metrics: [
      {
        title: '风险暴露度',
        description: '当前面临的风险总量',
        unit: '个',
        color: '#FF4D4F'
      },
      {
        title: '风险缓解率',
        description: '已缓解风险的比例',
        unit: '%',
        color: '#52C41A'
      },
      {
        title: '风险预警数',
        description: '需要关注的高风险项目',
        unit: '个',
        color: '#FAAD14'
      },
      {
        title: '风险解决率',
        description: '已解决风险的比例',
        unit: '%',
        color: '#1890FF'
      }
    ]
  }
};
